import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[queryNoOpinionToggle]' })
export class QueryNoOpinionToggleDirective {
    constructor(public template: TemplateRef<any>) {}
}
